query compromissoSelect($where: EnumItemDTOFilterInput) {
    data: tiposCompromissos(where: $where)  {
        label
        value
    }
}